import * as AppTypes from "AppTypes";
import { actionTypes } from "../actions";
import { IUserInfo } from "../types/appDataTypes";

export const initialState: IUserInfo = {
    addressInfo: {},
    artistInfo: {},
    artEntry: [],
    agreeMarketing: false
};

let persistStore = JSON.parse(window.sessionStorage.getItem("application-store"))
let persistUserInfo = persistStore && persistStore.userInfo
if (/verify=/.test(window.location.search)) {
    persistStore = undefined
    persistUserInfo = undefined
}

export const userInfoReducer = (state: IUserInfo = persistUserInfo || initialState, action: AppTypes.RootAction) => {
    switch (action.type) {
        case actionTypes.UPDATE_USER_DATA:
            return { ...state, ...action.payload }
        case actionTypes.UPDATE_PARENT_DATA:
            return { ...state, parentInfo: { ...state.parentInfo, ...action.payload } }
        case actionTypes.UPDATE_ADDRESS_DATA:
            return { ...state, addressInfo: { ...state.addressInfo, ...action.payload } }
        case actionTypes.UPDATE_ARTIST_DATA:
            return { ...state, artistInfo: { ...state.artistInfo, ...action.payload } }
        case actionTypes.UPDATE_ENTRY:
            {
                const { entryInfo, entryIndex } = action.payload
                const { artEntry = [] } = state
                artEntry[entryIndex] = { ...(artEntry[entryIndex] || {}), ...entryInfo }
                return { ...state, artEntry }
            }

        case actionTypes.DELETE_ENTRY:
            {
                const entryInfo = action.payload
                const { artEntry = [] } = state
                const index = artEntry.findIndex(e => e.entryId === entryInfo.entryId)
                artEntry.splice(index, 1)
                return { ...state, artEntry }
            }

        default:
            return state;
    }
};
